module.exports = __webpack_public_path__ + "media/images/countryrect/cw-8115be67f3c26a0eb81abaeaf1c234e5.svg";